import { useContext } from "react";
import { MiCuentaContext } from "contexts";

export function useMiCuenta() {
    const { montoPendiente,
        setMontoPendiente,
        montoColor,
        setMontoColor,
        montoTotal,
        setMontoTotal,
    } = useContext(MiCuentaContext);

    return {
        montoPendiente,
        setMontoPendiente,
        montoColor,
        setMontoColor,
        montoTotal,
        setMontoTotal,
    };
}
